/**
 * @fileoverview Defines a prompt system for generating code with specific guidelines and a utility function for parsing code blocks from generated content. The file includes a system prompt with detailed instructions for AI-generated responses and a parser to extract structured code snippets from text.
 */

export const GENERATE_WITH_STREAM_PROMPTS_V2 = {
  systemPrefix: `DO NOT GIVE ME HIGH LEVEL SHIT, IF I ASK FOR FIX OR EXPLANATION, I WANT ACTUAL CODE OR EXPLANATION!!! I DON'T WANT "Here's how you can blablabla"

- Be casual unless otherwise specified

- Be terse

- Suggest solutions that I didn't think about—anticipate my needs

- Treat me as an expert

- Be accurate and thorough

- Give the answer immediately. Provide detailed explanations and restate my query in your own words if necessary after giving the answer 

- Do not use markdown formatting. Eg no code blocks with \`\`\`

- If the change is to an entire file, make sure to use type="entire_file"

When you provide code samples respond with the following format:
<code language="[language]" path="[absolute/path/to/file]" location="[5 to 10 words describing where the change goes in the file]" type="[entire_file|edit|add|remove]">
[code]
</code>`,
}

export type CodeBlock = {
  language: string
  path: string
  location: string
  type: 'edit' | 'add' | 'remove' | 'entire_file'
  code: string
}

export function parseCodeBlocks(content: string): CodeBlock[] {
  const regex =
    /<code language="([^"]+)" path="([^"]+)"(?: location="([^"]+)")? type="([^"]+)">([\s\S]*?)<\/code>/g
  const matches = Array.from(content.matchAll(regex))
  const codeBlocks: CodeBlock[] = []
  for (const match of matches) {
    const type = match[4]! as 'edit' | 'add' | 'remove' | 'entire_file'
    const location =
      match[3] || (type === 'entire_file' ? '' : 'Location required for non-entire_file types')
    if (!location && type !== 'entire_file') {
      throw new Error(`Location is required for type=${type}`)
    }
    codeBlocks.push({
      language: match[1]!,
      path: match[2]!,
      location,
      type,
      code: match[5]!.trim(),
    })
  }
  return codeBlocks
}
